import React, { useState } from "react";

import DefaultPageLayout from "components/layouts/default-page-layout";
import useSetUrl from "app/main/admin/hooks/useSetUrl";
import OrgUnitPrimaryHeader from "app/main/orgUnits/components/orgUnit-primary-header";
import ScreenHeader from "components/items/screen-header";

import ReferralFormProfileForm from "../components/referralFormProfile-form";

const ReferralFormProfileNewPage = ({
  match: { params: { id, orgUnitType } },
  route,
  history,
}) => {
  useSetUrl(route);
  const [disabled, setDisabled] = useState(false);

  return (
    <>
      <OrgUnitPrimaryHeader orgUnitId={id} />
      <DefaultPageLayout
        header={<ScreenHeader title="Add Referral Form Profile" />}
        content={(
          <ReferralFormProfileForm
            submitLabel="Add"
            onCancel={() => setDisabled(true)}
            onSucceed={referralFormProfileId => history.push(`/admin/org-units/${orgUnitType}/${id}/referralFormProfiles/${referralFormProfileId}`)}
            orgUnitId={id}
            disabled={disabled}
          />
        )}
      />
    </>
  );
};

export default ReferralFormProfileNewPage;
